<template>
  <dialog-component
    :dialogData="dialogData"
    :isShow="isShow"
    :isPlain="true"
    :width="500"
    @cancel="isShow=false"
    @next="handleNext">
    <div class="tip-text">
      <span>
        An email will be sent to {{email}} to verify the shared login.
      </span><br>
      <span class="strong">This is mandatory for creating an account with a shared login.</span><br>
      <span>Continue?</span>
    </div>
  </dialog-component>
</template>

<script>
export default {
  name: 'verifyEmailDailog',
  props:{
    email:{
      type:String,
      default:''
    }
  },
  data(){
    return{
      isShow:false
    }
  },
  computed:{
    dialogData(){
      return{
        title:'Verify Email',
        buttonRightText:'Send & Continue'
      }
    }
  },
  methods:{
    handleShow(){
      this.isShow = true
    },
    handleNext(){
      this.isShow = false
      this.$emit('continue')
    }
  }

}
</script>

<style scoped lang="scss">
  .tip-text{
    font-size: 14px;
    line-height: 20px;
    color: #24292E;
    span{
      font-size: 14px;
      line-height: 20px;
      color: #24292E;
      word-break: break-word;
      display: block;
    }
    .strong{
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: #24292E;
    }
  }
</style>
